// repo/primary-care-connect/frontend/src/pages/Portal/CommunityNavigator/CaseDetail/components/DetailItem.tsx

import type { ReactNode } from "react";

type DetailItemProps = {
  label: string;
  value: ReactNode;
};

export default function DetailItem({ label, value }: DetailItemProps) {
  return (
    <div className="cn-case-detail-item">
      <dt>{label}</dt>
      <dd>{value || "—"}</dd>
    </div>
  );
}